import {Injectable} from '@angular/core';
import {RestApi} from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { IUserJob } from './core/IUserJob';


@Injectable()
export class AIJobsService {

  private _getEndPoint = 'api/SchedulerAI/UserJobs';
  private _updateEndpoint = 'api/SchedulerAI/UserJob';
  private _getEndPointStatus = 'api/SchedulerAI/StatusReset';
  private _resetStatus = 'api/SchedulerAI/Reset';

  constructor(private _restApi: RestApi) { }

  public getAll(): Promise<IUserJob[]> {
    return this._restApi.get(this._getEndPoint).toPromise();
  }

  public update(userJob: IUserJob):  Observable<any> {
    return this._restApi.put(`${this._updateEndpoint}/${userJob.guid}`, userJob);
  }

  public getStatusReset(customJobId: string): Observable<any> {
    return this._restApi.get(`${this._getEndPointStatus}/${customJobId}`);
  }

  public resetStatus(customJobId: string): Observable<any> {
    return this._restApi.post(`${this._resetStatus}/${customJobId}`, customJobId);
  }
}
